"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconCheck', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M12.6402 4.2318C13.0645 4.58537 13.1218 5.21593 12.7682 5.64021L7.76822 11.6402C7.58836 11.856 7.32599 11.9863 7.04531 11.999C6.76464 12.0117 6.49156 11.9058 6.29289 11.7071L3.29289 8.70713C2.90237 8.31661 2.90237 7.68344 3.29289 7.29292C3.68342 6.90239 4.31658 6.90239 4.70711 7.29292L6.9328 9.51861L11.2318 4.35984C11.5853 3.93556 12.2159 3.87824 12.6402 4.2318Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M16.6402 4.2318C17.0645 4.58537 17.1218 5.21593 16.7682 5.64021L9.26823 14.6402C9.0949 14.8482 8.84464 14.977 8.57465 14.9972C8.30466 15.0174 8.03801 14.9273 7.83565 14.7474L3.33565 10.7474C2.92286 10.3805 2.88568 9.74844 3.2526 9.33566C3.61952 8.92288 4.25159 8.8857 4.66437 9.25262L8.39273 12.5667L15.2318 4.35984C15.5854 3.93556 16.2159 3.87824 16.6402 4.2318Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M19.669 6.25671C20.0795 6.62617 20.1128 7.25846 19.7433 7.66897L10.7433 17.669C10.5598 17.8729 10.3005 17.9925 10.0263 17.9997C9.75204 18.0069 9.48688 17.9011 9.29289 17.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L9.96181 15.5476L18.2567 6.33104C18.6262 5.92053 19.2585 5.88726 19.669 6.25671Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M26.4762 7.36114C27.1052 7.90028 27.178 8.84723 26.6389 9.47621L14.6389 23.4762C14.367 23.7934 13.9751 23.9829 13.5576 23.9989C13.1401 24.015 12.7348 23.8561 12.4393 23.5607L5.43934 16.5607C4.85355 15.9749 4.85355 15.0252 5.43934 14.4394C6.02513 13.8536 6.97487 13.8536 7.56066 14.4394L13.4153 20.294L24.3611 7.52384C24.9002 6.89485 25.8472 6.82201 26.4762 7.36114Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;